export enum SchedulerStatus {
    NONE = 0,
    IN_PROGRESS,
    PAUSED,
    OFF
}

export function getPrettySchedulerStatus(schedulerStatus: SchedulerStatus): string {
    return { 0: 'Checking...', 1: 'In Progress', 2: 'Paused', 3: 'Off' }[schedulerStatus];
}
